export const resourceMap = {
    users: {
        list: 'v1/admin/users',
        getOne: id => `v1/admin/users/id/${id}`,
    },
    travels: {
        list: 'v1/admin/travels',
        getOne: id => `v1/admin/travels/id/${id}`,
    },
};
